require('../../sass/components/_inputSuffix.scss');

import {Input} from './Input';

export const InputWithSuffix = {
    name: 'InputWithSuffix',
    inheritAttrs: false,
    components: {
        Input
    },
    props: {
        isInvalid: Boolean,
        value: [String, Number],
        disabled: Boolean,
        type: String,
        suffix: String,
        suffixWidth: [Number, String],
        mask: [String, RegExp, Function],
        maskOptions: Object,
        name: String
    },
    computed: {
        inputStyle() {
            return {
                'padding-right': (this.suffixWidth || 0) + 'px'
            }
        },
        suffixStyle() {
            return {
                'width': this.suffixWidth + 'px'
            }
        },
        fieldId() {
            return !!this.name ? 'field_' + this.name : 'field_' + Math.random()
        }
    },
    template: `
        <div class="input-suffix">
            <Input :type="type"
                    :value="value"
                    class="input-suffix__input"
                    v-on="$listeners"
                    :mask="mask"
                    :maskOptions="maskOptions"
                    :style="inputStyle"
                    :disabled="disabled"
                    :isInvalid="isInvalid"
                    :id="fieldId"
                    :name="name"
                    v-bind="$attrs"/>
            <span class="input-suffix__suffix" :style="suffixStyle">{{ suffix }}</span>
        </div>
    `
};